import React from 'react'
import { Popover } from 'antd'
import { Icon } from '@iconify/react'

import styles from '../projectDetail.module.css'

const MenuItem = ({ icon, children, onClick, className = '', trailingIcon }) => (
    <div
        className={`${styles.menuItem} ${className}`.trim()}
        onClick={onClick}
    >
        <span className={styles.menuItemIcon}>
            <Icon icon={icon} width={16} height={16} />
        </span>
        <span className={styles.menuItemLabel}>{children}</span>
        {trailingIcon && (
            <Icon
                icon={trailingIcon}
                width={16}
                height={16}
                className={styles.menuItemChevron}
            />
        )}
    </div>
)

const ProjectTaskSectionMenu = ({
    sectionId,
    canDelete,
    isOnlySection,
    onRename,
    onAdd,
    onDelete,
}) => (
    <div className={styles.sectionMenu}>
        <MenuItem
            icon="mdi:pencil-outline"
            onClick={() => onRename(sectionId)}
        >
            Rename section
        </MenuItem>

        <Popover
            trigger="hover"
            placement="rightTop"
            mouseEnterDelay={0.1}
            getPopupContainer={() => document.body}
            classNames={{ root: styles.sectionMenuPopover }}
            content={
                <div className={styles.sectionMenu}>
                    <MenuItem
                        icon="mdi:arrow-left"
                        onClick={() => onAdd(sectionId, 'left')}
                    >
                        Add section to left
                    </MenuItem>
                    <MenuItem
                        icon="mdi:arrow-right"
                        onClick={() => onAdd(sectionId, 'right')}
                    >
                        Add section to right
                    </MenuItem>
                </div>
            }
        >
            <div>
                <MenuItem
                    icon="mdi:plus-box-multiple-outline"
                    trailingIcon="mdi:chevron-right"
                >
                    Add section
                </MenuItem>
            </div>
        </Popover>

        {canDelete && (
            <>
                <div className={styles.menuDivider} />
                <MenuItem
                    icon="mdi:trash-can-outline"
                    className={`${styles.deleteMenuItem} ${
                        isOnlySection ? styles.disabledMenuItem : ''
                    }`}
                    onClick={
                        isOnlySection ? undefined : () => onDelete(sectionId)
                    }
                >
                    Delete section
                </MenuItem>
            </>
        )}
    </div>
)

export default ProjectTaskSectionMenu
